// components
import RichText from '/react4xp/components/RichText'
import Section from '/react4xp/components/Section'

// css
import './index.scss'

// types
interface Props {
    text: string
}

export default function RichTextWrapper({
    text
}: Props) {
    return (
        <Section>
            <div className='container'>
                <div className='row'>
                    <div className='col-lg-10 offset-lg-1 col-xl-6 offset-xl-3'>

                        {text && (
                            <RichText>
                                {text}
                            </RichText>
                        )}

                    </div>
                </div>
            </div>
        </Section>
    )
}